import Vue from 'vue';
import Html2pdf from 'vue-html2pdf';

Vue.component('VueHtml2pdf', Html2pdf);
